<template>
  <div style="width: 100%">
    <div class="chart-header">
      <span>{{ title }}</span>
      <v-btn icon @click="toggleSort"><v-icon>mdi-sort</v-icon></v-btn>
    </div>
    <div style="overflow-y: auto;">
      <canvas ref="canvas" :height="height"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  props: {
    rawData: Array,
    title: String,
    height: {
      type: [Number, String],
      default: 400
    },
    formatAsPercent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: null,
      sortDescending: true,
      valuePlugin: null
    };
  },
  watch: {
    rawData: {
      handler() {
        this.renderChart();
      },
      deep: true
    }
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    toggleSort() {
      this.sortDescending = !this.sortDescending;
      this.renderChart();
    },

    registerPlugin() {
      this.valuePlugin = {
        afterDatasetsDraw: chart => {
          const ctx = chart.ctx;
          chart.data.datasets[0].data.forEach((value, i) => {
            const meta = chart.getDatasetMeta(0).data[i];
            if (!meta) return;

            ctx.save();
            ctx.font = '12px Arial';
            ctx.fillStyle = '#333';
            ctx.textAlign = 'left';
            const label = this.formatAsPercent
            ? `${Number.isInteger(value) ? value : value.toFixed(1)}%`
            : `${Math.round(value)}`;
            ctx.fillText(label, meta._model.x + 10, meta._model.y + 5);
            ctx.restore();
          });
        }
      };
    },

    renderChart() {
      if (this.chart) this.chart.destroy();
      this.registerPlugin();

      const sorted = [...this.rawData].sort((a, b) =>
        this.sortDescending ? b.value - a.value : a.value - b.value
      );

      const chartData = {
        labels: sorted.map(i => i.label),
        datasets: [{
          label: 'Percentual',
          backgroundColor: '#1A237E',
          data: sorted.map(i => i.value),
          barThickness: 20
        }]
      };

      this.chart = new Chart(this.$refs.canvas, {
        type: 'horizontalBar',
        data: chartData,
        options: {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
                padding: { right: 60 }
            },
            legend: { display: false },
            scales: {
                xAxes: [{
                ticks: {
                  beginAtZero: true,
                  max: 100,
                  callback: value => this.formatAsPercent
                  ? `${Number.isInteger(value) ? value : value.toFixed(1)}%`
                  : `${Math.round(value)}`
                }
                }],
                yAxes: [{
                  ticks: {
                    padding: 10,
                    fontSize: 12,
                    autoSkip: false,
                    maxRotation: 0,
                    minRotation: 0
                  },
                  afterFit: function (scale) {
                    const labels = scale.chart.data.labels || [];
                    const ctx = scale.chart.ctx;
                    ctx.save();
                    ctx.font = 'bold 12px Arial';
                    const maxWidth = labels.reduce((m, l) => Math.max(m, ctx.measureText(l).width), 0);
                    ctx.restore();
                    const padding = 24;                    
                    const minWidth = 120;                  
                    scale.width = Math.max(Math.ceil(maxWidth) + padding, minWidth);
                  }
                }
              ]
            },
            tooltips: {
                enabled: false
            }
        },

        plugins: [this.valuePlugin]
      });
    }
  }
};
</script>

<style scoped>
.chart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
}
</style>
